module.exports = __webpack_public_path__ + "static/media/watermark.979d3ced.svg";